import React, { forwardRef, useState } from 'react';
import { View } from 'react-native';

import JobCardFooter from './JobCardFooter';
import JobCardImage from './JobCardDetails/JobCardImage';

import { font as initialFont } from '@styles/fonts';
import { scale as initialScale } from '@components/frame';
import { JobCardPreviewProps } from '@v2/pages/planboard/types';

const JobCardPreview = forwardRef<View, JobCardPreviewProps>(({ font = initialFont, scale = initialScale, productionOperation, isPending, onMenuOpen, onMoveToPosition, onLinkBatch, onMarkAsFinished }, ref) => {
  const [isCardHovered, setIsCardHovered] = useState(false);

  return (
    <View ref={ref}>
      <JobCardImage
        font={font}
        scale={scale}
        item={productionOperation}
        isPending={isPending}
        onMenuOpen={onMenuOpen}
        onMoveToPosition={onMoveToPosition}
        onLinkBatch={onLinkBatch}
        onMarkAsFinished={onMarkAsFinished}
        isCardHovered={isCardHovered}
        onHoverChange={setIsCardHovered}
      />
      <JobCardFooter
        font={font}
        scale={scale}
        item={productionOperation}
        isPending={isPending}
        isCardHovered={isCardHovered}
        onHoverChange={setIsCardHovered}
      />
    </View>
  );
});

export default JobCardPreview;
